import { Action, createReducer, on } from '@ngrx/store';
import * as UserStateActions from './user-state.actions';

export const USER_STATE_FEATURE_KEY = 'userState';

export interface UserState {
    isAuthenticated: boolean;
    loggedInUser: Record<string, unknown> | null;
    userRoleData: Record<string, unknown> | null;
    userStatus: 'Active' | 'Inactive';
}

export interface UserStatePartialState {
    readonly [USER_STATE_FEATURE_KEY]: UserState;
}

export const initialState: UserState = {
    isAuthenticated: false,
    loggedInUser: null,
    userRoleData: null,
    userStatus: 'Active',
};

const userStateReducer = createReducer(
    initialState,
    on(UserStateActions.setIsAuthenticated, (state, { isAuthenticated }) => ({
        ...state,
        isAuthenticated,
    })),
    on(UserStateActions.setLoggedInUser, (state, { loggedInUser }) => ({
        ...state,
        loggedInUser,
    })),
    on(UserStateActions.setUserRoleData, (state, { userRoleData }) => ({
        ...state,
        userRoleData,
    })),
    on(UserStateActions.setUserStatus, (state, { userStatus }) => ({
        ...state,
        userStatus,
    })),
    on(UserStateActions.resetUserState, () => initialState),
);

export const reducer = (state: UserState | undefined, action: Action): UserState => {
    return userStateReducer(state, action);
};
